<template>
  <div class="aw-protocol">
    <div class="legal-notice" v-if="showCase == 1">
      <p class="protocol_title">海云捷迅法律声明</p>
      <br />
      <div class="protocol_time">
        更新时间: [2025.04.02] 
      </div>
      <div class="protocol_time">
        生效时间: [2025.04.02] 
      </div>
      <br />
      <!-- 更新日期: [具体更新日期] 生效日期: [具体生效日期] -->
      <div class="protocol_content">
        北京海云捷迅科技股份有限公司及其关联方（以下简称 “海云捷迅”、“公司” 或
        “我们”）就海云捷迅网页（包括 [公司网页域名]
        等网页及其信息介绍的子页面，以及通过 “注册”、“下载”、“咨询”
        等提交信息的页面，以下或称
        “本网站”、“海云捷迅网站”）的使用制定本《北京海云捷迅科技股份有限公司法律声明》（“本声明”）。
      </div>
      <br />
      <div class="protocol_content">
        感谢您访问海云捷迅网页！我们感谢您对海云捷迅的信任！
      </div>
      <br />
      <div class="protocol_content">
        我们提示您在使用海云捷迅网站的各项服务前，请您务必仔细阅读并透彻理解本声明，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用海云捷迅服务，将被视为对本声明内容的接受和认可。
        如您对本声明和/或本网站的产品、服务有任何疑问、意见或建议，或希望向海云捷迅提交投诉、举报内容，您可通过
        [联系电话] 与我们联系。
      </div>
      <div class="f_title">一、海云捷迅网站内容</div>
      <div class="protocol_content">
        海云捷迅可以在没有任何通知或提示的情况下随时对本网站上的内容进行修改，为了得到最新版本的信息，请定时访问本网站。海云捷迅在本网站上所提及的非海云捷迅产品或服务仅仅是为了提供相关信息，并不构成对这些产品、服务的认可或推荐。海云捷迅并不就本网站上提供的任何产品、服务或信息做出任何声明、保证或认可。
      </div>
      <div class="f_title">二、您对本网站的使用</div>
      <div>
        <h3 class="f_t_title">（一）使用目的限制</h3>
        您不得出于任何非法或本声明禁止的目的使用本网站和/或其包含的任何内容，不得将本网站和/或其包含的任何内容用于任何非法用途，也不得唆使任何非法活动或其他侵犯海云捷迅或他人权利的活动。

        <h3 class="f_t_title">（二）内容获取限制</h3>

        您不得通过本网站未提供的方式获取或试图获取本网站的任何内容，亦不得使用任何自动或手动的流程、抓取设备、程序、算法或方法，来访问、获取、拷贝或监控本网站的任何组成部分或内容。

        <h3 class="f_t_title">（三）安全措施禁止行为</h3>

        您不得以扫描等方式测试本网站和/或其网络是否存在漏洞，亦不得破坏本网站及其服务所采用的安全或身份验证措施。您不得反向搜索、跟踪或试图跟踪有关海云捷迅及本网站的任何其他用户或访客的任何信息；亦不得以任何方式滥用或泄露本网站内的任何服务或信息。

        <h3 class="f_t_title">（四）干扰正常运作禁止</h3>

        您不得以任何方式（包括但不限于使用任何设备、软件或程序）干扰或试图干扰本网站的正常运作及其他人对本网站的正常使用。

        <h3 class="f_t_title">（五）遵守法律法规与道德规范</h3>

        您同意在使用本网站及其内容时，遵守国家法律法规、社会公共道德。您不得利用本网站及其内容从事制作、查阅、复制和传播任何违法、侵犯他人权益等扰乱社会秩序、破坏社会稳定的行为，亦不得利用本网站及其内容从事任何危害或试图危害计算机系统及网络安全的活动。
        <h3 class="f_t_title">（六）账号注册与使用规范</h3>

        1.个人用户：在注册、使用本网站账号信息的过程中，如账号信息含有职业信息的，应当与个人真实职业信息相一致。<br />
        2.机构用户：注册、使用账号信息，应当与机构名称、标识等相一致，与机构性质、经营范围和所属行业类型等相符合。<br />

        <h3 class="f_t_title">（七）禁止发布信息类型</h3>
        您在注册、使用本网站账号信息以及使用本网站服务过程中，不得制作、复制、发布含有下列内容的信息：<br />
        1.反对宪法所确定的基本原则的；<br />
        2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br />
        3.损害国家荣誉和利益的；<br />
        4.歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<br />
        5.宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<br />
        6.煽动民族仇恨、民族歧视，破坏民族团结的；<br />
        7.破坏国家宗教政策，宣扬邪教和封建迷信的；<br />
        8.散布谣言，扰乱经济秩序和社会秩序的；<br />
        9.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
        10.侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；<br />
        11.使用夸张标题，内容与标题严重不符的； 12.炒作绯闻、丑闻、劣迹等的；<br />
        13.不当评述自然灾害、重大事故等灾难的；<br />
        14.带有性暗示、性挑逗等易使人产生性联想的；<br />
        15.展现血腥、惊悚、残忍等致人身心不适的；<br />
        16.煽动人群歧视、地域歧视等的； 17.宣扬低俗、庸俗、媚俗内容的；<br />
        18.可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；<br />
        19.法律、行政法规禁止的其他内容或其他对网络生态造成不良影响的内容。<br />
        <h3 class="f_t_title">（八）禁止假冒行为</h3>
        1.假冒、仿冒、捏造政党、党政军机关、企事业单位、人民团体和社会组织的名称、标识等；<br />
        2.假冒、仿冒、捏造国家（地区）、国际组织的名称、标识等；<br />
        3.假冒、仿冒、捏造新闻网站、报刊社、广播电视机构、通讯社等新闻媒体的名称、标识等，或者擅自使用
        “新闻”、“报道” 等具有新闻属性的名称、标识等；<br />
        4.假冒、仿冒、恶意关联国家行政区域、机构所在地、标志性建筑物等重要空间的地理名称、标识等；<br />
        <h3 class="f_t_title">（九）其他禁止行为</h3>
        1.以损害公共利益或者谋取不正当利益等为目的，故意夹带二维码、网址、邮箱、联系方式等，或者使用同音、谐音、相近的文字、数字、符号和字母等；<br />
        2.含有名不副实、夸大其词等可能使公众受骗或者产生误解的内容；<br />
        3.含有法律、行政法规和国家有关规定禁止的其他内容。<br />
        在您注册、使用和管理本网站账号信息以及使用本网站服务过程中，您还应当遵守《海云捷迅用户管理规则和公约》（[公约链接地址]）的相关规定。若本公司发现您注册、使用本网站账号信息或使用本网站服务过程中存在违反法律法规、本声明和/或《海云捷迅用户管理规则和公约》规定的，有权对您采取警示提醒、限期改正、限制功能、暂停使用/更新、关闭账号、禁止重新注册等处置措施。<br />
      </div>
      <div class="f_title">三、知识产权</div>
      <div class="protocol_content">
        本网站上使用和显示的所有商标、标志皆属海云捷迅或其权利人所有。未经海云捷迅或其他方事先书面许可，任何人不得以任何方式使用海云捷迅名称及海云捷迅的商标、标记。
        本网站所载的所有材料或内容受版权法的保护，所有版权由海云捷迅或其权利人拥有。未经海云捷迅或其他方事先书面许可，任何人不得将本网站上的任何内容以任何方式进行复制、修改、传播、经销、翻印、播放、拆解、反向工程、反编译、以超级链路连接或传送、以
        “镜像法” 载入其他服务器上、存储于信息检索系统或者其他任何的使用。
        本网站所有的产品、服务、技术与所有程序的知识产权均归属于海云捷迅或归其权利人所有，海云捷迅网站所载的任何内容不应被视作未经海云捷迅或其他方书面许可。
      </div>
      <div class="f_title">四、隐私</div>
      <div class="protocol_content">
        《海云捷迅网页隐私政策》（[隐私政策链接地址]）适用于本网站的使用。我们建议您在使用本网站前，务必仔细阅读并充分理解《海云捷迅网页隐私政策》的内容。
        当您在本网站上使用账户注册、下载服务、私有云方案规划咨询、人工智能方案规划咨询、整体解决方案咨询、参与调研、报名全国渠道巡展活动、报名培训课程、申请颁发证书、申请产品兼容性认证、申请试用公司产品、申请成为公司培训合作伙伴、创建工单、报备商机以及提交咨询问题或者申请预约沟通、意见反馈等服务，以及我们向您推荐产品或服务、发送消息通知、提供营销活动信息或您注册使用我们的技术论坛时，基于向您提供服务的目的，我们需要收集并使用您必要的个人信息，具体以《海云捷迅网页隐私政策》的说明为准。
      </div>
      <div class="f_title">五、免责声明</div>
      <div class="protocol_content">
        1.本网站所载的材料和信息，包括但不限于文本、图片、数据、观点、建议、网页或链路，虽然海云捷迅力图在本网站上提供准确的材料和信息，但海云捷迅并不保证这些材料和内容的准确、完整、充分和可靠性，并且明确声明不对这些材料和内容的错误或遗漏承担责任，也不对这些材料和内容作出任何明示或默示的、包括但不限于有关所有权担保、没有侵犯第三方权利、质量和没有计算机病毒的保证。<br />
        2.在任何情况下，对于因使用本网站内容或无法进入本网站而导致的任何直接的、间接的、附带的、给第三人造成的损失（包括但不限于利润损失、信息数据丢失、财产毁坏等损失），海云捷迅均无须承担法律责任，不论是采用合同之诉、侵权之诉或其他诉讼理由。<br />
        3.本网站可能保留有与第三方网站或网址的链接，访问这些链接将由用户自己作出决定，海云捷迅并不保证这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性。海云捷迅提供这些链接仅仅在于提供方便，并不表示海云捷迅对这些信息的认可和推荐，也不是用于宣传或广告目的。<br />
      </div>
      <div class="f_title">六、适用法律与争议解决</div>
      <div class="protocol_content">
        您同意，与您访问或使用本网站相关的所有事项，应根据中华人民共和国法律解释、理解和管辖。您同意，因本声明所引起或与其有关的任何争议应提交本公司所在地区的人民法院进行诉讼。
      </div>
    </div>
    <div class="privacy-policy" v-if="showCase == 2">
      <div class="protocol_title">海云捷迅网页隐私政策</div>
      <br />
      <div class="protocol_time">
        更新时间: [2025.04.02] 
      </div>
      <div class="protocol_time">
        生效时间: [2025.04.02] 
      </div>
      <br />
      <div class="aw-protocol-weight">
        北京海云捷迅科技股份有限公司（以下简称 “海云捷迅” 或
        “公司”、“我们”，注册地址为
        北京海淀区知春里28号楼四层405室就海云捷迅网页（以下或称
        “本网页”，包括 www.awcloud.com等网页及其信息介绍的子页面，以及通过
        “注册”“下载”“咨询”
        等提交信息的页面）的使用制定了本隐私政策。如某一具体海云捷迅产品或服务未设立独立隐私政策或其他个人信息处理规则的，则该部分产品或服务同样适用于本隐私政策，若相应产品或服务单独设立有隐私政策或其他个人信息处理规则的，则优先适用相关产品或服务的隐私政策、个人信息处理规则，相应隐私政策/个人信息处理规则中未涵盖的内容，本隐私政策有约定的，以本隐私政策内容为准。
      </div>
      <div class="protocol_content">
        感谢您访问海云捷迅网页！海云捷迅重视您的隐私，我们感谢您对海云捷迅的信任。
      </div>
      <div>
        本隐私政策（下称
        “隐私政策”）将解释对于您的个人信息之处理（包括但不限于收集、存储、使用、加工、传输、提供、公开、删除等），并规定了您对该等个人信息所持有的相关选择和权利。请仔细阅读并了解我们如何收集和使用您的个人信息，以及您可以如何控制这些个人信息非常重要。<span
          class="aw-protocol-weight"
          >对本隐私政策中与您的权益存在重大关系的条款和个人信息，我们将采用粗体字进行标识以提示您注意，对于我们收集的敏感个人信息，我们将进一步采用加下划线的方式进行显著标识以提示您关注。如果您不同意我们按照本隐私政策所述方式处理您的个人信息，请不要在收到请求时提供您的信息，并停止使用本网页。</span
        >
      </div>
      <div class="f_title">一、我们如何收集及使用您的个人信息</div>
      <div class="protocol_content">
        1.当您进行个人注册时，需要您填写并向我们提供
        <span class="aw-protocol-weight"
          >客户类型（个人客户、企业客户）以及账户信息（包括姓名、电子邮件地址、手机号码、验证码、登录密码）、您所属公司信息（公司名称、您在公司所担任的职位）、您公司在运营中遇到的问题等。</span
        >您注册完成后，可以通过您注册时提交的手机号登录本网页使用我们的服务，我们将通过发送
        <span class="aw-protocol-weight">短信验证码</span
        >的方式来验证您的身份是否有效。<br />
        当您以合作伙伴身份注册我们的渠道门户伙伴网站时，需要您填写并向我们提供您的<span
          class="aw-protocol-weight"
          >姓名、密码、职位、公司名称、</span
        >
        公司所在省市<span class="aw-protocol-weight">
          、验证码、电子邮件地址、手机号、海云捷迅邀约人。</span
        >您还可以进一步选择填写其他更多信息（包括公司注册资金、成立时间、意向合作行业、公司网站、公司介绍）。当您注册完成后，您可以使用<span
          class="aw-protocol-weight"
          >您的账号（电子邮件地址）、密码</span
        >进行登录以使用我们的服务。<br />
        2.当您提交产品/文档下载申请时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号，</span
        >以此联系到您及处理您的申请，并将下载链接通过邮件形式发送至您的邮箱或者在页面上直接提供下载地址。<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        >
        <br />
        3.当您提交私有云方案规划、人工智能方案规划咨询申请时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号、您希望咨询的方案内容，</span
        >以此了解您的身份以及所在行业需求，并联系到您以便与您沟通您咨询的方案内容。<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        4.当您参与本网页上的调研活动，填写海云捷迅调研问卷时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号以及您填写的调研问卷内容，</span
        >以此了解您的身份以及所在行业需求，并联系到您以便就您填写的调研问卷内容进行回访。在您填写调研问卷时，<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        5.当您报名海云捷迅自主举办的活动时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号、意向参会城市，</span
        >以此了解您的身份以及参会城市需求，并联系到您。<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        6.当您进行云计算课程培训、FPGA课程培训、数字技术工程师培训等海云捷迅认证培训课程咨询时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号、您希望咨询的认证培训内容，</span
        >以此了解您的身份，并联系到您以便与您沟通认证培训课程相关事宜。<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        7.当您需要申请云计算课程培训、FPGA课程培训、数字技术工程师培训等海云捷迅认证培训课程激活码，以便在激活成功后进行课程学习，您可以通过本网页上展示的方式联系我们的工作人员进行申请，并提交您的
        <span class="aw-protocol-weight"
          >申请课程、姓名、电话、电子邮件地址、城市、公司名称。</span
        >如您为学生，需向我们提供您的<span class="aw-protocol-weight"
          >学校名称、年级、专业。我们会在核实您的申请信息后，向您发送激活码。</span
        ><br />
        8.当您通过培训考核后，可申请海云捷迅与其他单位联合颁发证书时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、手机号、电子邮件地址、城市名称、公司/学校名称、证书类型，</span
        >以此核实您的申请信息，并联系到您以便与您沟通证书发放事宜。<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        9.当您申请产品兼容性认证时，我们将会收集您填写的<span
          class="aw-protocol-weight"
          >联系人姓名、公司名称、联系人电话、联系人电子邮件地址、证书邮寄地址、</span
        >产品名称、产品类型、产品架构、产品描述、公司
        logo、意向认证产品、测评方式，以此了解您的申请信息，并联系到您以便与您沟通认证事宜。<br />
        10.当您申请试用公司产品时（包括高级功能板块），我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号、您填写的希望通过海云捷迅解决的问题或需求，</span
        >以此联系到您并与您沟通产品试用事宜。<span class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        11.当您申请成为我们的培训合作伙伴时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、手机号、电子邮件地址、城市、公司名称、职位以及您填写的合作意向，</span
        >以此了解您的申请信息，并联系到您以便与您沟通申请成为培训合作伙伴相关事宜。<span
          class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        ><br />
        12.当您成为我们的试用客户或者付费客户后，如您遇到产品相关问题，您可以创建工单进行咨询，为此，您需要填写工单信息（包括问题优先级、工单标题、工单类型、产品、详情、机密信息、截图/日志文件、附件）、<span
          class="aw-protocol-weight"
          >提交人的姓名、联系人手机号、</span
        >方便联系时间、
        <span class="aw-protocol-weight">电子邮件地址、公司名称，</span
        >我们收到您提交的工单后将会协助您解决相应问题。<br />
        13.您可以通过本网页申请报备商机，我们将会收集项目信息（包括项目名称、预计签单日期、预计销售金额、项目背景、项目需求、项目规模、项目阶段、项目计划、采购方式、商机来源、项目跟进情况、竞争对手）、最终用户信息（包括最终用户企业全程、所在省份、所在城市、所属一级行业、所属二级行业）、<span
          class="aw-protocol-weight"
          >商机联系人信息（包括联系人姓名、角色、手机号码、电子邮件地址）</span
        >以及其他信息（包括<span class="aw-protocol-weight"
          >指定商机负责人、</span
        >合作伙伴公司名称、项目背景）。我们会审核您提交的商机报备信息并与您联系。<br />
        14.当您通过本网页提交咨询问题或者申请预约沟通、意见反馈时，我们将会收集您的<span
          class="aw-protocol-weight"
          >姓名、公司名称、电子邮件地址、手机号、您的需求或希望解决的问题、您反馈的意见内容。</span
        >以此联系到您并处理您的问题或需求。<span class="aw-protocol-weight"
          >我们将通过发送短信验证码的方式来验证您的身份是否有效。</span
        >当您拨打我们的客服电话进行咨询时，为便于尽快帮助您解决问题或记录相关问题的处理方案及结果，我们会通过电话录音的方式留存与您的<span
          class="aw-protocol-weight"
          >通话记录。</span
        ><br />
        15.基于向您推荐产品或服务、发送消息通知、提供营销活动信息，我们可能会自行或委托我们合作的服务商向您进行消息推送，包括基于您的<span
          class="aw-protocol-weight"
          >手机号码</span
        >通过短信或电话方式向您进行消息通知、向您的<span
          class="aw-protocol-weight"
          >电子邮件地址</span
        >发送消息，为此我们可能使用您提供的<span class="aw-protocol-weight"
          >姓名、公司名称、职务、电子邮件地址、手机号信息。</span
        ><br />
        16.当您收到我们的邀请或者您具备相应权限时，您可注册使用我们的技术论坛，我们会在该技术论坛上发布相关技术问题的解决方案等内容，您仅可进行查看和下载，不可发布其他信息。为此，我们会收集、使用您注册技术论坛时填写的<span
          class="aw-protocol-weight"
          >用户名、密码、注册原因、验证码以及电子邮件地址。</span
        ><br />
        <span class="aw-protocol-weight"
          >17.您充分知晓，以下情形中，我们处理您的个人信息无需征得您的授权同意：</span
        ><br />
        ①为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；<br />
        ②公共安全、公共卫生、重大公共利益有关的、或与犯罪侦查、起诉、审判和判决执行等有关的，为履行法定职责或者法定义务所必需；<br />
        ③为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        ④为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
        <br />
        ⑤依照《个人信息保护法》规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；<br />
        ⑥法律、行政法规规定的其他情形。<br />
        根据法律规定，经匿名化处理的个人信息不属于个人信息，对此类数据的处理将无需另行向您通知并征得您的同意。<br />
      </div>
      <div class="f_title">
        二、我们如何委托处理、共享、转让、公开披露您的个人信息
      </div>
      <div class="f_t_title">（一）委托处理</div>
      我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们提供某些服务或履行职能。我们仅会出于本隐私政策声明的合法、正当、必要、特定、明确的目的委托其处理您的个人信息，授权合作伙伴只能接触到其履行职责所需信息，且我们会要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其应当单独征得您的同意。<span
        class="aw-protocol-weight"
        >我们将信息委托给支持我们业务的授权合作伙伴处理，这些支持例如提供数据存储及配套服务、提供营销服务。</span
      >

      <div class="f_t_title">（二）共享</div>
      <div class="protocol_content">
        1.我们不会与海云捷迅以外的任何公司、组织和个人共享您的个人信息，<span
          class="aw-protocol-weight"
          >但以下情况除外：</span
        ><br />
        ①向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并事先获得您的单独同意；<br />
        ②根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；<br />
        ③在法律法规允许的范围内，为维护海云捷迅、您或社会公众利益、财产或安全免遭损害而有必要提供；<br />
        ④只有共享您的信息，才能实现我们的产品与 /
        或服务的核心功能或提供您需要的服务； <br />
        ⑤应您需求为您处理您与他人的纠纷或争议； <br />
        ⑥符合与您签署的相关协议或其他的法律文件约定所提供； <br />
        ⑦基于符合法律法规的社会公共利益而使用。<br />
        2.我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
        <div class="f_t_title">（三）转让</div>
        我们不会将您的个人信息转让给任何公司、组织和个人，<span class="aw-protocol-weight">但以下情况除外：</span><br/>
        如果我们因合并、收购、资产转让、分立、解散、被宣告破产等原因需要转移个人信息的，将向您告知接收方的名称或者姓名和联系方式。接收方应当继续履行个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，应当依法重新取得您的同意。
      
        <div class="f_t_title">（四）公开披露</div>
        我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：<br />
        1.根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br />
        2.根据法律、法规的要求、强制性的行政执法或司法要求。<br />
        <div class="f_t_title">（五）请您理解，根据法律法规规定，若基于上述第一条第 17 款项下所列情形，我们需要共享、转让、公开或以其他方式处理您的个人信息，无需征得您的同意。</div>
        <div class="f_title">三、Cookie 和同类技术的使用</div>
        
        为使您获得更轻松的访问体验，您访问本网页时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是
        Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称 “Cookie”）。<br />
        请您理解，我们的某些服务只能通过使用 “Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以在相关的页面修改对Cookie 的接受程度或者拒绝海云捷迅的Cookie，但这一举动在某些情况下可能会影响您使用海云捷迅网页提供的服务。<br />
        <div class="f_title">四、我们如何保护未成年人的个人信息</div>
        1.我们的产品主要面向企业客户，我们并不针对未成年人提供相应产品/服务。因此，我们不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。<br />
        2.我们非常重视对未成年人个人信息的保护。若您是 18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。<br />
        3.如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。<br />
        4.对于可能涉及的不满 14周岁的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且除法律、行政法规另有规定外，保存期限不会超过实现处理目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。我们会指定专人负责儿童个人信息保护事宜，并设立信息安全管理委员会。<br />
        <div class="f_title">五、我们如何存储和保护您的个人信息</div>
        我们仅在本隐私政策所述目的所必要的最短时间和法律法规要求的保存期限内保留您的个人信息，超出保存期限后，我们会按法律法规要求删除您的个人信息或进行匿名化处理。我们会按照法律法规规定，将您个人信息存储于中华人民共和国境内。我们的网页运维及技术团队位于中华人民共和国境内。我们将严格按照法律法规的规定，及根据本隐私政策，采取严格安全的保护措施，保护您的权利。<br />
        我们承诺维护您个人信息的安全和完整性。我们的信息安全与访问政策限制对我们的系统和技术进行访问，我们通过使用加密等技术保护措施来保护数据。遗憾的是，尽管我们已实施并保持合理措施来保护您的个人信息，通过互联网传输信息并不完全安全。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。<br />
        <div class="f_title">六、您的权利</div>
        1.查阅您的个人信息 <br />
        您有权查阅您的个人信息，您可以通过“登录公司官网账号-我的账户-账户信息”的方式自行查阅您的个人信息，但法律、行政法规规定另有规定的除外。<br />
        2.复制、转移您的个人信息 <br />
        您有权复制您的个人信息，您可以通过“登录公司官网账号-我的账户-账户信息” 的方式复制您的个人信息。<br />
        您有权转移您的个人信息，您可以通过发送邮件至marketing@awcloud.com的方式要求将您的个人信息转移至您指定的个人信息处理者，符合国家网信部门规定条件的，我们会提供转移的途径。<br />
        3.更正、补充您的个人信息<br />
        有权更正、补充您的个人信息，当您发现我们处理的关于您的个人信息有误或者不完整时，您可以通过
        “登录公司官网账号-我的账户-账户信息” 的方式进行更正、补充。<br />
        4.撤回或改变您的同意的范围<br />
        如我们基于您的同意处理您个人信息的，您可以通过发送邮件至marketing@awcloud.com的方式撤回或改变您的同意范围。您撤回同意的决定或改变同意范围的决定，不会影响此前基于您的同意而开展的个人信息处理。
        如您不希望我们通过电话、短信和 /
        或邮件方式向您发送营销服务信息等，您可以选择退订短信或者通过发送邮件至marketing@awcloud.com的方式申请取消营销信息通知的服务。<br />
        5.删除您的个人信息<br />
        6.您可以通过发送邮件至marketing@awcloud.com的方式向我们提出删除个人信息的请求。当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。如法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们会停止除存储和采取必要的安全保护措施之外的处理。<br />
        7.注销<br />
        如果您需要注销您的账号，您可以通过发送邮件至marketing@awcloud.com的方式申请注销账户。<br />
        8.对账户信息的生前安排<br />
        对个人信息提前进行生前安排，您可以通过本隐私政策公布的联系方式，通过书面方式告知我们您的安排；如无另行安排，您的近亲属可以基于其合法、正当利益，对您身后的相关个人信息依照相关法律规定和本隐私政策的约定，行使查阅、复制、更正、删除等权利。已故用户的近亲属可以通过发送邮件至
        marketing@awcloud.com的方式联系我们行使前述权利。 <br />
        9.响应您的上述请求<br />
        为保障安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在 15 天内做出答复。如您不满意，还可以通过发送邮件至marketing@awcloud.com的方式投诉。<br />
        对于您合理的请求，我们原则上不收取费用，但对
        <span class="aw-protocol-weight">多次重复、超出合理限度的请求，
        我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span>
        <div class="f_title">七、变更</div>
        我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享
        有的权利。我们会在本网页相关页面上发布对本隐私政策所做的任何变更。
        <span class="aw-protocol-weight">在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。</span>
        <div class="f_title">八、联系和投诉</div>
        1、如您对本隐私政策或您个人信息的相关事宜有任何问题、投诉、举报、意见或建议，请通过拨打客服热线4000-365-805与我们联系。<br />
        2、我们设立了个人信息保护负责人，您可以通过发送邮件至marketing@awcloud.com的方式与其联系。 <br />
        3、一般情况下，我们将在 15个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。
      </div>
    </div>
    <div class="legal-notice" v-if="showCase == 3">
        <div class="protocol_title">海云捷迅用户管理规则及公约</div>
        <br />
        <div class="protocol_time">
            更新时间: [2025.04.02] 
        </div>
        <div class="protocol_time">
            生效时间: [2025.04.02] 
        </div>
        <br />
        <div class="protocol_content">
            尊敬的用户（以下简称 “您”）：
            <br/>
            依据《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》、《互联网信息服务管理办法》、《互联网用户账号信息管理规定》、《网络信息内容生态治理规定》、《网站平台受理处置涉企网络侵权信息举报工作规范》等法律、行政法规、规章的规定，<span class="aw-protocol-weight">对于您注册账户并使用北京海云捷迅科技股份有限公司及其关联方（以下简称 “我们”）运营的海云捷迅网页（包括awcloud.com等网页及其信息介绍的子页面，以及通过 “注册”“下载”“咨询” 等提交信息的页面，以下简称 “本网站”）的行为，我们制定了如下管理规则和公约（以下简称 “本规则”），请您仔细阅读并认真遵守，与我们共创一个文明的网络环境。</span>
        </div>
        <div class="f_title">一、基本准则</div>
        <div class="protocol_content">1.您在注册、使用账号信息及使用本网站服务的过程中，应当遵守法律法规，遵循公序良俗，诚实信用，不得损害国家安全、社会公共利益或者他人合法权益。账号信息，是指您注册、使用的名称、认证信息等用于标识用户账号的信息。</div>
        <div class="f_title">二、账号信息规范</div>
        <div class="protocol_content">
            <span class="aw-protocol-weight">1.个人用户：</span>
            在注册、使用账号信息的过程中，如账号信息含有职业信息的，应当与个人真实职业信息相一致。<br/>
            <span class="aw-protocol-weight">2.机构用户：</span>
            注册、使用账号信息，应当与机构名称、标识等相一致，与机构性质、经营范围和所属行业类型等相符合。
        </div>
        <div class="f_title">三、账号信息禁止情形</div>
        <div class="protocol_content">
            1.您注册、使用的账号信息，不得有下列情形：<br/>
            • 违反《网络信息内容生态治理规定》第六条、第七条规定；<br/>
            • 假冒、仿冒、捏造政党、党政军机关、企事业单位、人民团体和社会组织的名称、标识等；<br/>
            • 假冒、仿冒、捏造国家（地区）、国际组织的名称、标识等；<br/>
            • 假冒、仿冒、捏造新闻网站、报刊社、广播电视机构、通讯社等新闻媒体的名称、标识等，或者擅自使用 “新闻”、“报道” 等具有新闻属性的名称、标识等；<br/>
            • 假冒、仿冒、恶意关联国家行政区域、机构所在地、标志性建筑物等重要空间的地理名称、标识等；<br/>
            • 以损害公共利益或者谋取不正当利益等为目的，故意夹带二维码、网址、邮箱、联系方式等，或者使用同音、谐音、相近的文字、数字、符号和字母等；<br/>
            • 含有名不副实、夸大其词等可能使公众受骗或者产生误解的内容；<br/>
            • 含有法律、行政法规和国家有关规定禁止的其他内容。<br/>
        </div>
        <div class="f_title">四、信息发布规范</div>
        <div class="protocol_content">
            1.违法信息禁止发布：您在使用本网站服务的过程中，不得制作、复制、发布含有下列内容的违法信息：<br/>
            • 反对宪法所确定的基本原则的；<br/>
            • 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br/>
            • 损害国家荣誉和利益的；<br/>
            • 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<br/>
            • 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<br/>
            • 煽动民族仇恨、民族歧视，破坏民族团结的；<br/>
            • 破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>
            • 散布谣言，扰乱经济秩序和社会秩序的；<br/>
            • 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br/>
            • 侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；<br/>
            • 法律、行政法规禁止的其他内容。<br/>
            2.不良信息禁止发布：您在使用本网站服务的过程中，不得制作、复制、发布含有下列内容的不良信息：<br/>
            • 使用夸张标题，内容与标题严重不符的；<br/>
            • 炒作绯闻、丑闻、劣迹等的；<br/>
            • 不当评述自然灾害、重大事故等灾难的；<br/>
            • 带有性暗示、性挑逗等易使人产生性联想的；<br/>
            • 展现血腥、惊悚、残忍等致人身心不适的；<br/>
            • 煽动人群歧视、地域歧视等的；<br/>
            • 宣扬低俗、庸俗、媚俗内容的；<br/>
            • 可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；<br/>
            • 其他对网络生态造成不良影响的内容。<br/>
            <span class="aw-protocol-weight">禁止实施侵权行为：</span><br/>
            您在使用本网站服务的过程中，不得实施侮辱、诽谤、威胁、散布谣言以及侵犯他人隐私等违法行为。不得制作、复制、发布混淆企业主体身份的仿冒性信息、影响公众公正评判的误导性信息、不符合企业客观实际的谣言性信息、贬损丑化企业或企业家的侮辱性信息、侵害企业家个人隐私的泄密性信息以及其他恶意干扰企业正常经营发展的信息，不得损害他人和其他企业主体的合法权益。如您使用本网站服务的过程中发现前述违法违规信息以及不良信息，您可以通过我们提供的方式进行投诉、举报。
        </div>
        <div class="f_title">五、注册与账号管理</div>
        <div class="protocol_content">
            1.如我们在核验您提交的注册信息或拟变更的账号信息过程中，发现您有违反本规则规定情形的，我们有权不予通过您的注册请求或变更账号信息请求。<br/>
            2.您申请注册相关账号信息，我们有权要求对您进行基于移动电话号码、身份证件号码或者统一社会信用代码等方式的真实身份信息认证，您不提供真实身份信息，或者冒用组织机构、他人身份信息进行虚假注册的，我们有权不为您提供相关服务。<br/>
            3.如果您的账号信息中含有特定敏感词汇（如涉及国家象征等相关内容，根据实际情况列举），我们将依照法律、行政法规和国家有关规定从严进行核验。<br/>
            4.我们将采取措施适时核验存量账号信息，若发现您的账号信息不符合法律、行政法规、规章或本规则要求的，将暂停向您提供服务并通知您限期改正；拒不改正的，我们将终止向您提供服务。<br/>
        </div>
        <div class="f_title">六、信用管理与违规处置</div>
        <div class="protocol_content">
            1.如我们在核验您提交的注册信息或拟变更的账号信息过程中，发现您有违反本规则规定情形的，我们有权不予通过您的注册请求或变更账号信息请求。<br/>
            2.您申请注册相关账号信息，我们有权要求对您进行基于移动电话号码、身份证件号码或者统一社会信用代码等方式的真实身份信息认证，您不提供真实身份信息，或者冒用组织机构、他人身份信息进行虚假注册的，我们有权不为您提供相关服务。<br/>
            3.如果您的账号信息中含有特定敏感词汇（如涉及国家象征等相关内容，根据实际情况列举），我们将依照法律、行政法规和国家有关规定从严进行核验。<br/>
            4.我们将采取措施适时核验存量账号信息，若发现您的账号信息不符合法律、行政法规、规章或本规则要求的，将暂停向您提供服务并通知您限期改正；拒不改正的，我们将终止向您提供服务。<br/>
        </div>
        <div class="f_title">七、信息保护承诺</div>
        <div class="protocol_content">
            请您放心，我们将依法保护和处理互联网用户账号信息中的个人信息，并采取措施防止未经授权的访问以及个人信息泄露、篡改、丢失。
        </div>
        <div class="f_title">八、咨询与投诉渠道</div>
        <div class="protocol_content">如果您对本规则有任何疑问，或在使用本网站过程中存在任何疑问，或希望进行投诉、举报的，您可以拨打客服热线4000-365-805 与我们联系。</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showCase: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
};
</script>
